import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfMichigan = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Michigan"
      universityShortName="UMich"
      slug="university-of-michigan"
      seoTitle="UMich Study Rooms | Shapiro and Hatcher Library Study Spaces"
      seoDescription="Find study rooms at University of Michigan including Shapiro and Hatcher Libraries. Learn about floor noise levels and CSW as an online alternative."
      seoKeywords="UMich study rooms, University of Michigan library, Shapiro Library, Ann Arbor study spaces, Wolverine study rooms"
      canonicalUrl="/study-room/university-of-michigan/"
      heroDescription="Navigate UMich's floor-by-floor noise zones from social basement to silent fourth floor."
      libraryWebsiteUrl="https://lib.umich.edu"
      libraryWebsiteName="UMich Library"
      studySpaces={[
        {
          name: "Hatcher/Shapiro - Study Rooms",
          features: "Up to 3 hours/day, 9 hours/week. Soundproof booths available.",
          feedback: "Check in with MCard at first-floor desk. 30-min cancellation policy."
        },
        {
          name: "Shapiro - Basement",
          features: "Fairly quiet, good for focused individual work.",
          feedback: "Quieter than main floor. Good starting point."
        },
        {
          name: "Shapiro - First Floor",
          features: "Social and noisy, collaborative tables.",
          feedback: "Good for group work and socializing."
        },
        {
          name: "Shapiro - Fourth Floor",
          features: "Silent floor, students wear headphones to block last bits of sound.",
          feedback: "Ultimate quiet. Perfect for intense focus."
        }
      ]}
      guideContent={
        <>
          <p>
            Hatcher and Shapiro Libraries allow individuals and groups to reserve study rooms and soundproof booths 
            for up to three hours per day and nine hours per week. The person who made the reservation must check in 
            with their MCard at the first-floor information desk.
          </p>
          <p className="mt-4">
            Reservations are cancelled if no one checks in within 30 minutes. Clean-up expectations require users 
            to remove trash and personal items. Shapiro Library has stark differences across floors.
          </p>
          <p className="mt-4">
            Pick your floor based on your noise tolerance: the basement is fairly quiet; the first floor is social 
            and noisy; the third floor has more technology but moderate noise; the fourth floor is silent, with 
            students wearing headphones to block the last bits of sound.
          </p>
        </>
      }
      summaryTips={[
        "Book up to 3 hours/day, 9 hours/week",
        "Check in with MCard within 30 minutes",
        "Fourth floor is the silent study zone",
        "First floor is social and collaborative",
        "Soundproof booths available for reservations"
      ]}
    />
  );
};

export default UniversityOfMichigan;
